import NodeEnvironment from '../../../Shared/Constants/NodeEnvironment';

const renderTestId = (id: string): string => {
    const environment = process.env.NODE_ENV;

    if (
        environment === NodeEnvironment.DEVELOPMENT ||
        environment === NodeEnvironment.TEST
    ) {
        return id;
    }

    return null;
};

export default renderTestId;